import { SlideDialog } from '@components/Dialogs/SlideDialog';
import { FieldType, FormValueFragmentFragment, useFormTemplateQuery, usePreviewProjectFormQuery } from 'gql/index';
import React from 'react';
import { useIntl } from 'react-intl';
import { FormTemplateActions } from './FormTemplateActions';
import { FormViewer } from './FormViewer/FormViewer';

interface Props {
  open: boolean;
  onClose?: () => void;
  projectFormId?: number;
  templateId?: number;
}

export const FormEditorPreviewDrawer: React.FC<Props> = ({ open, onClose, projectFormId, templateId }) => {
  const { formatMessage } = useIntl();

  const { data: projectForm } = usePreviewProjectFormQuery({ projectFormId: projectFormId ?? 0 }, {
    gcTime: 0,
    select: d => d.projectForm?.formDefinition,
    enabled: (!!projectFormId && open)
  });

  const { data: formTemplate } = useFormTemplateQuery({ id: templateId ?? 0 }, {
    gcTime: 0,
    select: d => d.formTemplate,
    enabled: (!!templateId && open)
  });

  const matrixDefaultValues = (projectForm ?? formTemplate?.formDefinition)?.sections
    .flatMap(p => p.fields)
    .filter(p => p.fieldType === FieldType.Matrix)
    .map<FormValueFragmentFragment>(p => ({
      id: p.id,
      documents: [],
      selectedOptions: [],
      fieldId: p.id,
      matrixRows: p.matrix?.defaultRows ?? []
    })) ?? [];

  return (
    <SlideDialog
      open={open}
      onClose={onClose}
      topbar={{
        title: formatMessage({ id: 'Preview' }),
        actionButton: formTemplate ? (
          <FormTemplateActions template={formTemplate} />
        ) : undefined
      }}
      containerProps={{ maxWidth: 'xl' }}
    >
      {formTemplate?.formDefinition && (
        <FormViewer
          editable
          definition={formTemplate.formDefinition}
          values={matrixDefaultValues}
        />
      )}

      {projectForm && (
        <FormViewer
          editable
          definition={projectForm}
          values={matrixDefaultValues}
        />
      )}
    </SlideDialog>
  );
};